<section>
    <h1>Jinkies!</h1>
    <p>We can't find that page!</p>
</section>

<style>
    section {
        display: flex;
        flex-direction: column;
    }

    h1{
        text-align: center;
        margin-bottom: 0;
    }
    p{
        text-align: center;
    }
</style>